module.exports = __webpack_public_path__ + "static/img/产后提臀裤.4eafc3dc.jpg";